// Turn a caught API error into a message that is safe to show a user (Session AEH, FIX-1 A3).
//
// The server attaches a plain-English message on its 4xx/5xx paths that reads like a sentence (a
// space, real words, ending punctuation). A bare machine code -- "site_has_active_contracts",
// "P2002", "FST_FILES_LIMIT" -- must never reach the office as-is. This generalises the proven
// AcceptQuote.tsx sentence-check (surface server text ONLY when it reads like a sentence, else the
// caller's fallback) so every office err.code call site shares one rule.
import { ApiError } from "./api";

export function friendlyApiError(err: unknown, fallback: string): string {
  if (err instanceof ApiError && typeof err.code === "string") {
    const msg = err.code.trim();
    // A human sentence has a space between words. A machine code (snake_case, dotted, ALL_CAPS,
    // a Prisma Pxxxx) does not, so the space test alone is the same guard AcceptQuote ships.
    if (msg.includes(" ")) return msg;
  }
  return fallback;
}
